import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { LogOut, Menu } from 'lucide-react';
import Sidebar from './Sidebar';
import ParticlesBackground from './ParticlesBackground';
import {
  LayoutContainer,
  Header,
  HeaderContent,
  Logo,
  UserSection,
  UserName,
  LogoutButton,
  MenuButton,
  MainContent,
  FloatingElement
} from './Layout.styles';

const Layout = () => {
  const { user, logout } = useAuth();
  // Initialize sidebar state - start closed for cleaner look, user can toggle
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <LayoutContainer>
      <ParticlesBackground />
      
      <FloatingElement delay="0s" />
      <FloatingElement delay="3s" />
      <FloatingElement delay="6s" />

      <Sidebar isOpen={sidebarOpen} onToggle={toggleSidebar} />

      <Header>
        <HeaderContent sidebarOpen={sidebarOpen}>
          <MenuButton onClick={toggleSidebar}>
            <Menu size={24} />
          </MenuButton>
          <Logo>CMS Dashboard</Logo>
          <UserSection>
            <UserName>Welcome, {user?.email || 'Admin'}</UserName>
            <LogoutButton onClick={handleLogout}>
              <LogOut size={18} />
              Logout
            </LogoutButton>
          </UserSection>
        </HeaderContent>
      </Header>

      <MainContent sidebarOpen={sidebarOpen}>
        <Outlet />
      </MainContent>
    </LayoutContainer>
  );
};

export default Layout;
